var config;

try {
  config = require('./config');
} catch (e) {
  config = require('./config.dev');
}
/**
 * 获取 SDK 配置信息
 * @return {Object}
 */


var getConfig = function getConfig() {
  return config;
}; // 获取SDK类型


var getAppType = function getAppType() {
  var config = getConfig();
  var type; // h5

  if (typeof wx !== 'undefined') {
    // 小程序
    type = 'wx';
  } else if (typeof window !== 'undefined') {
    type = 'h5';
  } else if (process === global.process) {
    // 快应用功能
    type = 'nodejs';
  } else if (config.type === 3) {
    // 快应用功能
    type = 'hap';
  } else {
    // 默认H5
    type = 'h5';
  }

  return type;
};

module.exports = {
  getConfig: getConfig,
  getAppType: getAppType
};